import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, AfterViewInit, SimpleChange } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';
import { NormasService } from 'app/_services/normas.service';

@Component({
  selector: 'modalmoverevidencia',
  templateUrl: './modalmoverevidencia.component.html',
  styleUrls: ['./modalmoverevidencia.component.css']
})


export class ModalmoverevidenciaComponent implements OnInit, AfterViewInit, OnChanges {


  @Input() _mostrarmodal: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Input() _id_evidencia: any; 

  @Output() onChangeModal = new EventEmitter<any>();

  mostrarmodal: boolean = false;
  listaBloques: any;
  listaAreas: any;
  listaModulos: any;

  constructor(private normasService: NormasService) { }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    this.getListaBloques();

  }



  ngOnInit() {
  }

  ngAfterViewInit(){
    this.abrirModal();
  }


  getListaBloques(){
    console.log('get lista bloqeus');
    this.normasService.getListaBloques().subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listaBloques = data.json().lista;
            this.listaBloques.id_bloque = -1;
            console.log(this.listaBloques);
            this.getListaAreas(this.listaBloques[0].id_bloque);
           
          }
        }
      }
    );
  }

 
  getListaAreas(id_bloque: number){
    this.normasService.getListaAreas(id_bloque).subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listaAreas = data.json().lista;
            this.listaAreas.id_area = -1;
            console.log(this.listaAreas);
            this.getListaModulos(this.listaAreas[0].id_area);
          }
        }
      }
    );
  }

  getListaModulos(id_area:number){
    this.normasService.getListaModulos(id_area).subscribe(
      data => {
        if (data){
          if (data.json().lista){
            this.listaModulos = data.json().lista;
            this.listaModulos.id_modulo=-1;
            console.log(this.listaModulos);
          }
        }
      }
    );
  }

  cargaAreas(bloqueseleccionado){
    this.getListaAreas(bloqueseleccionado);
  }

  cargaModulos(areaSeleccionada){
  this.getListaModulos(areaSeleccionada)
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(value: boolean){

    this.staticModalRespuestas.hide();
    this.onChangeModal.emit(value);
  }



}



// WEBPACK FOOTER //
// ./src/app/modalmoverevidencia/modalmoverevidencia.component.ts